import { dispatchEvent } from '@homeexchange/shared';

import store from '../store';

function resolveSenderId(senderId) {
    return Number(senderId) || Number(store.getState().auth?.userId) || 0;
}

export function notifyConversationUpdated(conversationId, senderId) {
    const id = Number(conversationId);
    if (!id) {
        return;
    }

    dispatchEvent('conversations:message-received', {
        conversationId: id,
        senderId: resolveSenderId(senderId)
    });
}
